import React from 'react'
import { IMarketplaceCartItem } from '../../../types/cart'
import AddToCartDialogPresentational from '../../../components/add-to-cart-dialog'

interface IAddToCartDialog {
  addedProduct: IMarketplaceCartItem
  setAddedProduct: (result: IMarketplaceCartItem | undefined) => void
}

const AddToCartDialog: React.FunctionComponent<
  React.PropsWithChildren<IAddToCartDialog>
> = ({ addedProduct, setAddedProduct }) => (
  <AddToCartDialogPresentational
    isOpen={true}
    onContinueShopping={() => setAddedProduct(undefined)}
    shop={addedProduct.shop}
    sku={addedProduct.sku}
    title={addedProduct.name}
    brand={addedProduct.brand}
    productImage={addedProduct.image}
    variantText={addedProduct.optionValues.map(o => o.value).join(', ')}
    price={addedProduct.listPrice}
    discountedPrice={addedProduct.discountPrice || undefined}
    applicablePromotions={addedProduct.variant.promotions}
    quantity={addedProduct.quantity}
    maxQuantity={10}
    isItemLinked={false}
    returnable={undefined}
  />
)

export default AddToCartDialog
